import { Classified, Vehicle } from '@groupelacentrale/classified-core';
import { Deposit, VehicleConditionOptions, VehicleType } from 'types';
import { SetStateAction } from 'react';
import { getCookie } from 'utils/cookies';
import { getVehicleInterior, getVehicleExterior } from './vehicleBody';
import strings from './strings';
import { VEHICLE_REPAIRS } from './vehicleRepairs';
import { isImported } from './vehicleVersion';

export const getDepositTypeFromCookies = (fallback: VehicleType): VehicleType => {
  const origin = getCookie('origin');
  let depositType = fallback;
  if (origin && depositType === 'UNKNOWN') {
    depositType = origin.split('/').pop()!.toUpperCase() as VehicleType;
  }
  return depositType;
};

export const restoreDepositState = (classified: Classified): SetStateAction<Deposit> => {
  const depositType = (localStorage.getItem('depositType') || 'UNKNOWN') as VehicleType;
  const vehicle: Vehicle = classified.vehicle;
  const registration = vehicle.registerNumber;
  const equipmentsOrOptions = vehicle.equipmentsOrOptions?.map(item => item.label);
  const repairs = VEHICLE_REPAIRS[depositType].map(r => ({
    label: r,
    selected: vehicle.repairs && vehicle.repairs.includes(r),
  }));
  const condition = vehicle.condition
    ? VehicleConditionOptions.find(c => strings.normalize(c) === strings.normalize(vehicle.condition!))
    : undefined;
  const imported = isImported(vehicle.origin);

  const { seatMaterial, internalColor } = getVehicleInterior(vehicle.internalColor!);
  const { paintType, externalColor } = getVehicleExterior(vehicle.externalColor!);
  delete vehicle.registerNumber;

  const networkWarranty = classified.networkWarranty;

  return (prevState: Deposit): Deposit => ({
    ...prevState,
    attempt: 0,
    contacts: classified.contacts,
    reference: classified.reference,
    depositType: depositType,
    vehicle: {
      ...vehicle,
      registration,
      equipmentsOrOptions,
      repairs,
      condition,
      internalColor,
      externalColor,
      paintType,
      seatMaterial,
      imported,
      firstCirculationDate: vehicle.firstCirculationDate ? new Date(vehicle.firstCirculationDate) : undefined,
      ...networkWarranty,
    },
    referencePro: classified.referencePro,
    price: classified.price,
    zipCode: classified.zipCode,
    verifiedPhone: classified.contacts?.phone1?.value,
  });
};
